import { IInsuranceDocuments } from '../shared';

export class InsuranceDocumentDto {
  readonly documents: Array<{
    guid: string;
    type: string;
    name: string;
    reason: string | null;
    history?: Array<{
      guid: string;
      type: string;
      name: string;
      reason: string | null;
    }>;
  }>;
  constructor(entity: IInsuranceDocuments) {
    this.documents = [
      ...entity.contract_documents,
      ...entity.insurance_documents.map((doc) => ({
        ...doc,
        name: doc.filename,
        reason: null,
        history: [],
      })),
    ];
  }
}
